import { useState } from "react";
import { HeartPulse, Menu, X } from "lucide-react";
import { scrollToId } from "@/App";

const LINKS = [
  ["What we do", "what-we-do"],
  ["How it works", "how-it-works"],
  ["Pricing", "pricing"],
  ["About", "about"],
  ["FAQ", "faq"],
];

export const Nav = () => {
  const [open, setOpen] = useState(false);

  const go = (id) => {
    setOpen(false);
    scrollToId(id);
  };

  return (
    <header className="sticky top-0 z-50 w-full border-b border-[#E7E3D9] bg-[#F8F7F4]/95 backdrop-blur">
      <div className="mx-auto flex h-[72px] max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8">
        <button
          data-testid="nav-logo"
          onClick={() => { setOpen(false); window.__lenis ? window.__lenis.scrollTo(0) : window.scrollTo(0, 0); }}
          className="flex items-center gap-2 font-display text-xl sm:text-2xl font-bold tracking-tight text-[#1E7B4F]"
        >
          <HeartPulse className="h-7 w-7 text-[#F97316]" strokeWidth={2.2} />
          Desk to Defib
        </button>
        <nav className="hidden items-center gap-8 md:flex">
          {LINKS.map(([label, id]) => (
            <button
              key={id}
              data-testid={`nav-${id}-link`}
              onClick={() => go(id)}
              className="text-sm font-medium text-[#14231B] underline-offset-8 decoration-2 decoration-[#F97316] hover:text-[#1E7B4F] hover:underline transition-colors duration-300"
            >
              {label}
            </button>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <button
            data-testid="nav-book-btn"
            onClick={() => go("book")}
            className="inline-flex items-center justify-center whitespace-nowrap rounded-full bg-[#1E7B4F] px-4 py-2.5 text-xs sm:px-5 sm:text-sm font-semibold text-white shadow-sm hover:bg-[#16603D] transition-colors duration-300"
          >
            Book a session
          </button>
          <button
            data-testid="nav-mobile-toggle"
            onClick={() => setOpen((o) => !o)}
            aria-label="Toggle menu"
            className="inline-flex items-center justify-center rounded-full border border-[#E7E3D9] bg-white p-2.5 text-[#14231B] md:hidden"
          >
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>
      {open && (
        <nav className="border-t border-[#E7E3D9] bg-[#F8F7F4] px-4 py-4 md:hidden" data-testid="nav-mobile-menu">
          {LINKS.map(([label, id]) => (
            <button
              key={id}
              data-testid={`nav-mobile-${id}-link`}
              onClick={() => go(id)}
              className="block w-full py-3 text-left text-base font-medium text-[#14231B] underline-offset-8 decoration-2 decoration-[#F97316] hover:text-[#1E7B4F] hover:underline"
            >
              {label}
            </button>
          ))}
        </nav>
      )}
    </header>
  );
};
